var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwindCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 45.5082C61.6663 45.5082 53.3331 52.1732 49.9994 65.5019C55 58.8369 60.8334 56.3385 67.4997 58.0041C71.3036 58.9544 74.0221 61.7142 77.032 64.7679C81.9339 69.7422 87.6072 75.4994 100.001 75.4994C113.333 75.4994 121.667 68.8344 125 55.5044C120.001 62.1694 114.167 64.6691 107.5 63.0035C103.697 62.0531 100.978 59.2933 97.9686 56.2397C93.0668 51.2653 87.3921 45.5082 75 45.5082V45.5082ZM49.9994 75.4994C36.6669 75.4994 28.3325 82.1644 25 95.4943C29.9994 88.8294 35.8328 86.3297 42.5003 87.9965C46.303 88.9481 49.0215 91.7067 52.0314 94.7591C56.9332 99.7334 62.6079 105.492 75 105.492C88.3338 105.492 96.6669 98.8268 100.001 85.4969C95 92.1618 89.1666 94.6615 82.5003 92.9947C78.6964 92.0456 75.9779 89.2845 72.968 86.2321C68.0662 81.2578 62.3928 75.4994 49.9994 75.4994V75.4994Z",
    fill: "#06B6D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindCss);
export default __webpack_public_path__ + "static/media/TailwindCss.172e2c4a05c0359cdfd08d20c7e9ad08.svg";
export { ForwardRef as ReactComponent };